import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const selectAuth = (state: RootState) => state.auth;

export const selectTimezone = () => createSelector(
  [selectAuth],
  (auth) => {
    return auth.timezone;
  }
);